import { useRef, useState } from "react";
import { Upload, Link as LinkIcon, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export function ImageUploader({ value, onChange, label = "Image", testid = "image", aspect = "aspect-video" }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/upload", fd);
      onChange(data.url);
      toast.success("Image uploaded");
    } catch {
      toast.error("Upload failed. Try a smaller image.");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      {label && <label className="text-sm font-medium text-[#1A231C]">{label}</label>}
      <div className="mt-1 flex gap-3 items-start">
        <div className={`w-28 ${aspect} rounded-lg overflow-hidden bg-[#F4EFE6] border border-[#E8E4D9] flex items-center justify-center shrink-0`}>
          {value ? (
            <img src={value} alt="preview" className="w-full h-full object-cover" />
          ) : (
            <span className="text-[#9CA3AF] text-xs">No image</span>
          )}
        </div>
        <div className="flex-1 space-y-2">
          <button
            type="button"
            data-testid={`${testid}-upload-btn`}
            onClick={() => inputRef.current?.click()}
            disabled={uploading}
            className="inline-flex items-center gap-2 bg-[var(--brand-primary)] text-white text-sm px-3 py-2 rounded-lg hover:bg-[var(--brand-primary-hover)] transition-colors disabled:opacity-60"
          >
            {uploading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />}
            {uploading ? "Uploading..." : "Upload from device"}
          </button>
          <input
            ref={inputRef}
            type="file"
            accept="image/*"
            onChange={handleFile}
            className="hidden"
            data-testid={`${testid}-file-input`}
          />
          <div className="relative">
            <LinkIcon className="w-4 h-4 text-[#9CA3AF] absolute left-3 top-1/2 -translate-y-1/2" />
            <input
              data-testid={`${testid}-url-input`}
              value={value || ""}
              onChange={(e) => onChange(e.target.value)}
              placeholder="or paste image URL"
              className="w-full bg-white border border-[#E8E4D9] rounded-lg pl-9 pr-3 py-2 text-sm focus:outline-none focus:border-[var(--brand-primary)]"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImageUploader;
